@import 'styles/mixins';
@import 'styles/variables';

.container {
  @include z-index(overlay);
  background-color: $white;
  background-image: url('https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1649943968/public/screen_backgrounds/doc_permisson_background_mlrmfy.png');
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;

  &.inHandbook {
    z-index: auto; // don't overlap the collapsed side on mobile
    position: relative;
  }
}

.logoContainer {
  margin-top: 72px;
  text-align: center;

  svg {
    width: 240px;
    height: 54px;
  }
}

.permissionRequestCard {
  width: 100%;
  max-width: 560px;
  margin-top: 52px;
  padding: 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: $white;
  box-shadow: 0px 8px 8px rgba(135, 84, 186, 0.05), 0px 4px 8px rgba(135, 84, 186, 0.08),
    0px 2px 4px rgba(135, 84, 186, 0.1), 0px 12px 24px rgba(238, 130, 96, 0.1);
  border-radius: 8px;

  @media (max-width: $mediumDevicesMinWidth) {
    padding: 32px 10px;
    width: 90%;
  }

  .title {
    color: $grey-90;
    @include header-xxl-regular-serif;
    text-align: center;
    letter-spacing: -0.02em;
  }

  .textInfo {
    @include md-regular;
    color: $black;
    padding: 0px 56px;
    text-align: center;
    margin-top: 32px;
  }

  .buttonsWrapper {
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    row-gap: 8px;

    .buttonText {
      padding: 0px 42px;
      @media (max-width: $mediumDevicesMinWidth) {
        padding: 0px;
      }
    }
  }

  .switchAccountWrapper {
    margin-top: 32px;
    width: 100%;
  }
}
